import { createSelector } from "@reduxjs/toolkit";

import { createDeepEqualSelector } from "../utils/createDeepEqualSelector";
import { selectAllAccounts } from "../accounts/selectors";

import { formatBulkTemplate } from "./helpers";

import type { RootState } from "../store";
import type { FormattedBulkTemplate } from "./types";

// basic selectors
export const selectBulkTemplatesState = (state: RootState) =>
  state.bulkTemplates;

export const selectBulkTemplatesById = createSelector(
  [selectBulkTemplatesState],
  (bulkTemplatesState) => bulkTemplatesState.byId,
);

export const selectBulkTemplatesPageMap = createSelector(
  [selectBulkTemplatesState],
  (bulkTemplatesState) => bulkTemplatesState.pageMap,
);

export const selectBulkTemplatesTotal = createSelector(
  [selectBulkTemplatesState],
  (bulkTemplatesState) => bulkTemplatesState.total,
);

export const selectFormattedPaginatedBulkTemplates = createDeepEqualSelector(
  [
    selectBulkTemplatesPageMap,
    selectBulkTemplatesById,
    selectAllAccounts,
    (_, pageNumber: number) => pageNumber,
  ],
  (pageMap, byId, accounts, pageNumber): FormattedBulkTemplate[] => {
    const ids = pageMap[pageNumber] ?? [];

    return ids.reduce<FormattedBulkTemplate[]>((acc, id: string) => {
      const template = byId[id];
      if (template) {
        acc.push(formatBulkTemplate(template, accounts));
      }
      return acc;
    }, []);
  },
);
